import { FormControl, FormGroup } from '@angular/forms';
import { PropertyMetadata } from '../../../properties/property-types';
import { RegisterElement } from '../../element-decorator';
import { PolygonMapItem } from '../polygon-map-item';

@RegisterElement()
export class Pillar extends PolygonMapItem {
    public override TypeName: string = "Pillar";
    public override ParentType: string | null = "ParkingLevel";
    public override ParentFormGroupName: string | null = "MapItems";

    constructor(formGroup: FormGroup) {
        super(formGroup, "Pillar");
        
        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
        if (!formGroup.contains('Width')) {
            formGroup.addControl('Width', new FormControl(0.4)); // 40cm default width
        }
        if (!formGroup.contains('Length')) {
            formGroup.addControl('Length', new FormControl(0.4)); // 40cm default length
        }
        if (!formGroup.contains('Shape')) {
            formGroup.addControl('Shape', new FormControl('square'));
        }
        
        if(formGroup.contains('StrokeColor'))
            this.OutlineColor = '#' + formGroup.get('StrokeColor')?.value;
        else
            this.OutlineColor = "#444444";
        if(formGroup.contains('FillColor'))
            this.FillColor = '#' + formGroup.get('FillColor')?.value;
        else
            this.FillColor = "#555555";
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Pillar Name',
                inputType: { type: 'text' },
                order: 1,
                category: 'General'
            },
            {
                formControlName: 'Width',
                displayName: 'Width',
                inputType: { 
                    type: 'dimension',
                    unit: 'meters'
                },
                order: 2,
                category: 'Dimensions'
            },
            {
                formControlName: 'Length',
                displayName: 'Length',
                inputType: { 
                    type: 'dimension',
                    unit: 'meters'
                },
                order: 3,
                category: 'Dimensions'
            },
            {
                formControlName: 'Shape',
                displayName: 'Shape',
                inputType: { 
                    type: 'select',
                    options: [
                        { value: 'square', label: 'Square' },
                        { value: 'round', label: 'Round' },
                        { value: 'rectangular', label: 'Rectangular' }
                    ]
                },
                order: 4,
                category: 'Properties'
            }
        ];
    }

    public override default(): Pillar {
        const width = this.formGroup.get('Width')?.value || 0.4;
        const length = this.formGroup.get('Length')?.value || 0.4;
        
        this.points = [
            { x: 0, y: 0 },
            { x: width, y: 0 },
            { x: width, y: length },
            { x: 0, y: length }
        ];
        return this;
    }

    public override clone(): Pillar {
        return new Pillar(this.formGroup);
    }

} 
